/* Common Imports */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  sectionMobile: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  image: {
    borderRadius: "0.32rem",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      height: "223.77px",
      width: "396.44px",
    },
    [theme.breakpoints.only("xs")]: {
      height: "223.77px",
      width: "396.44px",
    },
    [theme.breakpoints.only("sm")]: {
      height: "400px",
      width: "711.11px",
    },
    [theme.breakpoints.only("md")]: {
      height: "531.33px",
      width: "944px",
    },
    [theme.breakpoints.only("lg")]: {
      height: "531.33px",
      width: "944px",
    },
    [theme.breakpoints.only("xl")]: {
      height: "531.33px",
      width: "944px",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      height: "531.33px",
      width: "944px",
    },
  },
}));

const CarouselImage = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <img
          src={
            props.thumbnailLink
              ? props.thumbnailLink
              : "/images/other/about_gallery/about_gallery_1.webp"
          }
          alt={props.imageAltText}
          width={1000}
          height={531.33}
          loading="lazy"
          referrerPolicy="no-referrer"
          className={classes.image}
        />
      </div>
      <div className={classes.sectionMobile}>
        <img
          src={
            props.thumbnailLink
              ? props.thumbnailLink
              : "/images/other/about_gallery/about_gallery_1.webp"
          }
          alt={props.imageAltText}
          width={379}
          height={223.77}
          loading="lazy"
          referrerPolicy="no-referrer"
          className={classes.image}
        />
      </div>
    </React.Fragment>
  );
};

export default CarouselImage;
